module.exports = __webpack_public_path__ + "static/img/9.a635df2.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/9/sp/9.png
// module id = saQb
// module chunks = 0